import { TagColor as Color, Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface ImportProjectTagTypeProps {
  importProjectType: string
}

const ImportProjectTypeTag = ({ importProjectType }: ImportProjectTagTypeProps) => {
  const importProjectTypeTagColor: Record<string, Color> = {
    new: Color.lime,
  }
  const type = importProjectTypeTagColor[importProjectType]

  const getLabel = (): string => {
    switch (importProjectType) {
      case 'new':
        return i18n.t('project_management.tags.import_project_types.new')
      default:
        return ''
    }
  }

  return (
    <Tag inline type={type}>
      {getLabel()}
    </Tag>
  )
}

export default ImportProjectTypeTag
